/* global axios */
import ApiClient from '../ApiClient';

class BrainDataManagerAPI extends ApiClient {
  constructor() {
    super('brain/assistants', { accountScoped: true });
  }

  configUrl(assistantId) {
    return `${this.url}/${assistantId}/data_manager`;
  }

  get({ assistantId }) {
    return axios.get(this.configUrl(assistantId));
  }

  update({ assistantId, ...dataManagerConfig }) {
    return axios.patch(this.configUrl(assistantId), {
      data_manager: dataManagerConfig,
    });
  }
}

export default new BrainDataManagerAPI();
